import styled from "@emotion/styled";
import { ThemeProp } from "../../../styles/theme";

export const NetworkDropdownContainer = styled.div<ThemeProp>(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  flex: "1 0 0",
}));
